import {put, call, takeLatest} from 'redux-saga/effects'
import * as actions from "../modules/auth"
import {api, requestError} from "../../components/helpers"
import {notifyRequestResult} from "../modules/notify";
import { getAuthTokens, updateAuthTokens } from 'utils/cookies';

export const ERROR_AS_SUCCESS_GENERATE = 'already-generated';

function* errorHandler(error: any) {
  const errorMessage = requestError(error);
  yield put(notifyRequestResult(errorMessage, 'error'));
  return errorMessage
}

function* getUser(): any {
  yield put(actions.authStart());
  try {
    const response = yield call(api.get, 'Account/GetCurrentAppUser');
    yield put(actions.authSuccess(response.data));
  } catch (error) {
    // TODO: if Error Axios try update Token
    // yield put(actions.checkLoggedFail());
    return error;
  }
}
function* checkUserLogged(): any {
  yield put(actions.authStart());

  const response = yield call(api.get, 'Auth/CheckAuth');

  if (response.data !== "not-authorize") {
    yield* getUser();
    return;
  }

  const { token, refreshToken, expires } = getAuthTokens();
  

  if (!refreshToken || !token) {
    yield put(actions.checkLoggedFail());
    return;
  }

  try {
    const responseRefresh = yield call(api.post, "Auth/RefreshToken", {
      token,
      refreshToken,
    });

    updateAuthTokens({
      token: responseRefresh.data.token,
      refreshToken: responseRefresh.data.refreshToken,
      expires: expires,
    })

    const response = yield call(api.get, 'Auth/CheckAuth');

    if (response.data !== "not-authorize") {
      yield* getUser();
      return;
    }

    updateAuthTokens();
    yield put(actions.checkLoggedFail());

  } catch {
    yield put(actions.checkLoggedFail());
    return;
  }
}

function* authUser(action: any): any {
  yield put(actions.authStart());
  try {
    const {cookie: _cookie, ...data} = action.data;
    const response = yield call(api.post, 'Auth/LoginWithCode', data);
    if (response.status === 200) {
      try {
        yield call(getUser);
      } catch (error) {
        const errorMessage = yield call(errorHandler, error);
        yield put(actions.authFail(errorMessage));
      }
    } else {
      const errorMessage = yield call(errorHandler, response);
      yield put(actions.authFail(errorMessage));
    }
  } catch (error) {
    const errorMessage = yield call(errorHandler, error);
    yield put(actions.authFail(errorMessage));
  }
}

// @ts-ignore
function* authCode(action: any): any {
  yield put(actions.authStart());
  try {
    yield call(api.post, 'Auth/GeneratePassword', action.data);
    yield put(actions.authCodeSuccess());
  } catch (error) {
    if (requestError(error) === ERROR_AS_SUCCESS_GENERATE) {
      yield put(actions.authFail(requestError(error)));
    } else {
      const errorMessage = yield call(errorHandler, error);
      yield put(actions.authFail(errorMessage));
    }
  }
}

function* logout() {
  yield put(actions.authStart());
  try {
    yield call(api.post, 'Auth/Logout');
    yield put(actions.logoutSucceed());
  } catch (error) {
    const errorMessage = requestError(error);
    yield put(notifyRequestResult(errorMessage, 'error'));
    yield put(actions.authFail(errorMessage));
  }
}

export default [
  takeLatest('AUTH_GET_USER', getUser),
  takeLatest('AUTH_CHECK_USER_LOGGED', checkUserLogged),
  takeLatest('AUTH_USER', authUser),
  takeLatest('AUTH_CODE', authCode),
  takeLatest('AUTH_INITIATE_LOGOUT', logout),
];
